import { device } from 'app/ui-components/breakpoints';
import { playGrey15, regularWhite } from 'app/ui-components/design-tokens';
import { playFontSize } from 'app/ui-components/typography/helpers';
import { playFocus, VisuallyHidden } from 'app/ui-components/utils.styles';
import styled from 'styled-components';

export const SkipLinkWrapper = styled.div`
    position: relative;
`;

export const StyledSkipLink = styled.a`
    ${VisuallyHidden}
    ${playFocus()}
    ${playFontSize(1.5)}
    color: ${regularWhite};
    box-sizing: border-box;
    text-align: center;
    padding: 0.24em;
    z-index: 2;
    background-color: ${playGrey15};
    text-decoration: none;

    @media ${device.GteSmall} {
        ${playFontSize(1.6)}
    }

    &:hover,
    &:active,
    &:focus {
        text-decoration: underline;
    }

    &:focus {
        display: block;
        position: static !important; /* stylelint-disable-line declaration-no-important */
        height: auto;
        width: 100%;
        margin: 3px 0 0;
        outline: none;
    }
`;
